import React from 'react';
import { Button, Checkbox, Input, Form } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import {
  loginIsLogin,
  loginModalOpen,
  loginLegalIssuesModalOpen,
} from 'app/actions/Login/login.action';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { userConstants } from 'app/constants/user.constants';

import { FormattedMessage } from 'react-intl';
import { getUserHistory } from 'actions/Users/user.history.action';
import {
  PASSWORD,
  FORGOT_PASSWORD,
  START_LOGIN,
} from '../../../../constants/enter.user.constants';
import CheckLegalIssues from '../../../Utility/CheckLeggalIssues/legalIssues';
import userEnterStore from '../userEnter.service';
import userAPI from '../../../../API/user.service.api';

import AbstractMachine from './abstractMachine';

export default class Password extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = PASSWORD;
    this._nextState = START_LOGIN;
  }

  getTitle = () => {
    return <FormattedMessage id="Login" defaultMessage="Login" />;
  };

  isShowFreePro = () => {
    return false;
  };

  submitWithPassword = (e, isLegalOn) => {
    this._form
      .validateFields()
      .then((values) => {
        const { userEmail, password, remember, legalIssues } = values;
        if (userEmail && password) {
          this._goTo(null, this.login, {
            login: userEmail,
            passwd: password,
            isRemember: remember ? 1 : 0,
            legalIssues: legalIssues ? 1 : 0,
            isLegalOn,
          });
        }
      })
      .catch((err) => {
        const { password, userEmail } = err;
        if (userEmail) {
          this._goTo(null, this.setError, {
            ...userEmail.errors[0],
            name: this._name,
            isLegalOn,
          });
        } else if (password && !userEmail) {
          this._goTo(null, this.setError, {
            ...password.errors[0],
            name: this._name,
            isLegalOn,
          });
        }
      });
  };

  onChangePassword = (e, error, isLegalOn) => {
    if (error && e.target.value > 2) {
      this._goTo(null, this.setError, {
        error: '',
        name: this._name,
        isLegalOn,
      });
    }
  };

  setError = (dispatch, { message, name, isLegalOn }) => {
    dispatch(setStateUserEnter({ name, error: message, isLegalOn }));
  };

  showSendNewPasswdFunction = () => {
    this._goTo(FORGOT_PASSWORD);
  };

  moveLegalWindowTop = (dispatch) => {
    dispatch(loginLegalIssuesModalOpen(true));
  };

  onLegalIssuesChange = () => {
    this._goTo(null, this.moveLegalWindowTop);
  };

  login = (dispatch, params) => {
    params.apiMethod = 'loginWeb';

    function success(user) {
      return { type: userConstants.LOGIN_SUCCESS, user };
    }

    userAPI
      .login(params)
      .then(
        ({ code, response = {}, message = '' }) => {
          if (code !== 200) {
            const state = {
              name: this._name,
              error: message,
              isLegalOn: params.isLegalOn,
            };
            dispatch(setStateUserEnter(state));
          } else {
            const user = response.userdata;
            if (user) {
              userEnterStore.set(user);
              dispatch(success(user));
              dispatch(loginIsLogin(true));
              dispatch(loginModalOpen(false));
              dispatch(setStateUserEnter({ name: this._nextState }));
              dispatch(getUserHistory(user.id));
            } else {
              console.info(`User is not defined - ${user}`);
            }
          }
        },
        (error) => {
          console.info(`passwordnot 200 ${error}`);
        }
      )
      .then(() => {
        userAPI.loginJWT(params).then((response) => {
          const { accessToken } = response;
          localStorage.setItem('token', accessToken);
        });
      })
      .catch((error) => console.info(`passwordcetch ${error}`));
  };

  render(props) {
    let { error } = props;
    const { isLegalOn, loginText = {} } = props;
    error = error && error.indexOf('pass') !== -1 ? error : null;
    return (
      <div className="continueDivRender">
        {this.getMainInput(props)}

        <Form.Item
          style={{ width: '100%' }}
          validateStatus={error ? 'error' : 'success'}
          help={
            error ? (
              <FormattedMessage
                id={
                  error.charAt(0).toUpperCase() +
                  error.replace(/_/g, ' ').slice(1)
                }
                defaultMessage={
                  error.charAt(0).toUpperCase() +
                  error.replace(/_/g, ' ').slice(1)
                }
              />
            ) : (
              ''
            )
          }
          name="password"
          rules={[
            { required: true, message: loginText['Write your password'] },
          ]}
        >
          <Input
            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder={loginText.Password}
            ref={props.ref}
            onChange={(e) => this.onChangePassword(e, error, isLegalOn)}
            onPressEnter={(e) => this.submitWithPassword(e, isLegalOn)}
          />
        </Form.Item>

        {!isLegalOn ? (
          <CheckLegalIssues
            form={this._form}
            clickHandler={this.onLegalIssuesChange}
          />
        ) : null}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '-11px',
            width: '100%',
          }}
        >
          <Form.Item
            style={{ marginBottom: '0px' }}
            name="remember"
            valuePropName="checked"
            initialValue
          >
            <Checkbox style={{ fontSize: '12px' }}>
              <FormattedMessage id="Remember me" defaultMessage="Remember me" />
            </Checkbox>
          </Form.Item>

          <Button
            type="link"
            className="ant-btn-primary"
            onClick={this.showSendNewPasswdFunction}
            style={{
              fontSize: '12px',
              float: 'right',
              padding: 0,
              position: 'relative',
              top: '1px',
            }}
          >
            <span>
              <FormattedMessage
                id="Forgot password"
                defaultMessage="Forgot password"
              />
            </span>
          </Button>
        </div>

        <Button
          type="primary"
          style={{ marginTop: '11px', marginBottom: '18px' }}
          className="ant-btn-primary width100"
          onClick={(e) => this.submitWithPassword(e, isLegalOn)}
        >
          <span>
            <FormattedMessage id="Login" defaultMessage="Login" />
          </span>
        </Button>
      </div>
    );
  }
}
